import { Avatar, useTheme } from '@mui/material'
import NavigationOutlinedIcon from '@mui/icons-material/NavigationOutlined'
import { CarIconProps } from './types'

const CarIcon = ({ lightingColor, color, style, sx }: CarIconProps) => {
  const theme = useTheme()
  const boxShadow = lightingColor
    ? `0 0 0 2px ${theme.palette.common.white}, 0 0 0 4px ${lightingColor}`
    : `0 0 0 2px ${theme.palette.common.white}`
  return (
    <Avatar
      style={style}
      sx={{
        backgroundColor: color,
        width: "fit-content",
        height: "fit-content",
        padding: "2px",
        boxShadow
      }}
    >
      <NavigationOutlinedIcon
         sx={{
          fontSize: { xs: "6px", md: "10px" },
          ...sx
         }}
      />
    </Avatar>
  )
}

export default CarIcon
